<script lang="ts" setup>
import AppInput from "~/components/ui/form/formElements/AppInput.vue";
import type {IInput} from "~/shared/interfaces/ui/form/formInputs";
import type {IValidationData, TPasswordErrors} from "~/shared/interfaces/validator";

const props = defineProps<{
  label: string
  id: string
  isHint: boolean
  isFullWidth?: boolean
  isValidation?: boolean
  errorMessage?: string
  clearInput?: boolean
  hideErrorMessage?: boolean
}>()

const emits = defineEmits(['pass-password'])

const passwordConfig = ref<IInput>({
  inputConfig: {
    type: 'password',
    label: props.label,
    id: props.id,
    interactiveLabel: true,
    hideErrorMessage: props.hideErrorMessage
  },
  validatorConfig: {
    required: true,
    passwordFormat: true,
  },
})

const password = ref<string | boolean>('')
const passwordErrorsFields: TPasswordErrors[] = ['length', 'numbers', 'lower', 'upper', 'symbol']
const passwordErrors = ref<Record<TPasswordErrors, boolean>>({
  length: true,
  upper: true,
  lower: true,
  numbers: true,
  symbol: true
})

function handleInput(event: IValidationData) {
  if (event.errorInfo.hasError) {
    passwordErrorsFields.forEach(el => {
      passwordErrors.value[el] = !!event.errorInfo.passwordErrors?.includes(el)
    })
    password.value = false
  } else {
    passwordErrorsFields.forEach(el => {
      passwordErrors.value[el] = false
    })
    password.value = event.value
  }

  emits('pass-password', event)
}
</script>


<template>
  <div
    class="password"
    :class="isFullWidth && 'password_full-width'"
  >
    <AppInput
      :input-config="passwordConfig.inputConfig"
      :validator-settings="isValidation ? passwordConfig.validatorConfig : undefined"
      @get-data="handleInput"
      :error-message="errorMessage"
      ref="input"
      :clear-input="clearInput"
    />
    <div
      class="password__hint"
      v-if="isHint"
    >
      Придумайте пароль от
      <span :class="passwordErrors.length && 'highlight'">8 знаков:</span>
      из
      <span :class="passwordErrors.numbers && 'highlight'">цифр</span>,
      <span :class="passwordErrors.symbol && 'highlight'">символов</span>,
      <span :class="passwordErrors.upper && 'highlight'">заглавных</span>
      и
      <span :class="passwordErrors.lower && 'highlight'">строчных</span>
      букв латинского алфавита
    </div>
  </div>
</template>

<style lang="scss" scoped>
.password {
  display: flex;
  gap: 16px;
  align-items: center;

  &_full-width {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;

    .input {
      width: 100% !important;
    }
  }

  .input {
    width: 290px;
  }

  &__hint {
    @include font(14px, 20px);

    span {
      transition: color .3s;
      &.highlight {
        color: $content_negative;
      }
    }
  }
}
</style>
